import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/header.tsx");
